"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _InputAction = _interopRequireWildcard(require("../InputAction"));
var _InputActions = _interopRequireDefault(require("../InputActions"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _utils = require("../utils");
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _FormControl = _interopRequireWildcard(require("@mui/material/FormControl"));
var _InputBase = _interopRequireDefault(require("@mui/material/InputBase"));
var _styles = require("@mui/material/styles");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _get = _interopRequireDefault(require("lodash/get"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["disabled", "className"],
  _excluded2 = ["inputProps"],
  _excluded3 = ["actionCount", "expandedWidth"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DISABLED_SEARCH_CLASS_NAME = 'GgSearch-disabled';
var FOCUSED_CLASS_NAME = 'focused';
var Search = (0, _styles.styled)(function (_ref) {
  var disabled = _ref.disabled,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx4["default"])(className, _defineProperty({}, DISABLED_SEARCH_CLASS_NAME, disabled))
  }));
})(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    transition: theme.transitions.create(['background-color', 'border-radius']),
    '&:hover': {
      backgroundColor: theme.palette.action.selected
    }
  }, "&:has(.MuiInputBase-input.".concat(FOCUSED_CLASS_NAME, "), &:has(.MuiInputBase-input.").concat(FILLED_INPUT_CLASS_NAME, ")"), {
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius
  }), "marginLeft", 0), "width", '100%'), theme.breakpoints.up('sm'), {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }), "&.".concat(DISABLED_SEARCH_CLASS_NAME), {
    color: theme.palette.action.disabled,
    backgroundColor: theme.palette.action.disabledBackground
  });
});
var SearchIconWrapper = (0, _styles.styled)('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2
  };
});
var DebounceInputBase = (0, _utils.withInputDebounce)()(_InputBase["default"]);
var FILLED_INPUT_CLASS_NAME = 'GgInput-filled';
var DebounceInputBaseWithFilledClassName = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var inputProps = _ref5.inputProps,
    props = _objectWithoutProperties(_ref5, _excluded2);
  var muiFormControl = (0, _FormControl.useFormControl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DebounceInputBase, _objectSpread(_objectSpread({}, props), {}, {
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      className: (0, _clsx4["default"])(inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, _defineProperty({}, FILLED_INPUT_CLASS_NAME, muiFormControl.filled))
    }),
    ref: ref
  }));
});
var StyledInputBase = (0, _styles.styled)(function (_ref6) {
  var _ = _ref6.actionCount,
    __ = _ref6.expandedWidth,
    props = _objectWithoutProperties(_ref6, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DebounceInputBaseWithFilledClassName, _objectSpread({}, props));
})(function (_ref7) {
  var theme = _ref7.theme,
    _ref7$actionCount = _ref7.actionCount,
    actionCount = _ref7$actionCount === void 0 ? 0 : _ref7$actionCount,
    expandedWidth = _ref7.expandedWidth;
  return {
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': _defineProperty({
      boxSizing: 'border-box',
      height: "calc(1.554em + ".concat(theme.spacing(2), ")"),
      padding: theme.spacing(1, 0, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: "calc(1.143em + ".concat(theme.spacing(3), ")"),
      transition: theme.transitions.create(['width']),
      cursor: 'pointer'
    }, theme.breakpoints.up('sm'), _defineProperty(_defineProperty({
      width: '0ch'
    }, "&.".concat(FOCUSED_CLASS_NAME, ", &.").concat(FILLED_INPUT_CLASS_NAME), {
      width: expandedWidth || '200px',
      cursor: 'text'
    }), "&.".concat(FILLED_INPUT_CLASS_NAME), {
      paddingRight: "calc(".concat(22 * actionCount, "px + ").concat(theme.spacing(1), " )")
    }))
  };
});
var SearchActions = function SearchActions(_ref8) {
  var children = _ref8.children,
    expanded = _ref8.expanded;
  var _useFormControl = (0, _FormControl.useFormControl)(),
    filled = _useFormControl.filled,
    focused = _useFormControl.focused;
  return filled || focused || expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputActions["default"], {
    children: children
  }) : null;
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function SearchInput(_ref9, ref) {
  var _ref9$placeholder = _ref9.placeholder,
    placeholder = _ref9$placeholder === void 0 ? 'Search...' : _ref9$placeholder,
    valueProp = _ref9.value,
    onChange = _ref9.onChange,
    onEnter = _ref9.onEnter,
    onClear = _ref9.onClear,
    helperText = _ref9.helperText,
    disabled = _ref9.disabled,
    debounceTimeout = _ref9.debounceTimeout,
    actions = _ref9.actions,
    tooltip = _ref9.tooltip,
    expandedWidth = _ref9.expandedWidth,
    expanded = _ref9.expanded;
  var debounceInputRef = _react["default"].useRef();
  var _React$useState = _react["default"].useState({
      controlled: valueProp
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var handleClear = function handleClear(e) {
    (0, _get["default"])(debounceInputRef, 'current.cancel', _noop["default"])(e);
    if (valueProp) {
      onChange === null || onChange === void 0 || onChange(e, '');
      onEnter === null || onEnter === void 0 || onEnter(e, '');
    }
    if (value) {
      setValue('');
    }
    onClear === null || onClear === void 0 || onClear();
  };
  var handleChange = function handleChange(e) {
    var newValue = e.target.value;
    if (e.type === 'blur') {
      setFocused(false);
      return;
    }
    setValue(newValue);
    onChange === null || onChange === void 0 || onChange(e, newValue);
    if (e.key === 'Enter' && newValue) {
      onEnter(e, newValue);
    }
    if (!newValue && valueProp) {
      onEnter(e, '');
    }
  };
  _react["default"].useEffect(function () {
    if (valueProp !== value) {
      setValue(valueProp);
    }
  }, [valueProp]);
  var actionsToRender = [];
  if (value) {
    actionsToRender.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAction["default"], {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Clear["default"], {}),
      onClick: handleClear,
      tooltip: "Clear"
    }, 'clear'));
  }
  if (helperText) {
    actionsToRender.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAction.InputIcon, {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.HelpOutlineIcon, {}),
      tooltip: helperText
    }, 'helper'));
  }
  if (actions !== null && actions !== void 0 && actions.length) {
    actionsToRender.push.apply(actionsToRender, _toConsumableArray(_react["default"].Children.map(actions, function (child, index) {
      return /*#__PURE__*/_react["default"].isValidElement(child) ? (/*#__PURE__*/_react["default"].cloneElement(child, {
        key: "search-action-".concat(index)
      })) : child;
    })));
  }
  var actionCount = actionsToRender.length;
  var _React$useState3 = _react["default"].useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focused = _React$useState4[0],
    setFocused = _React$useState4[1];
  var inputRef = _react["default"].useRef(null);
  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setFocused(true);
        inputRef.current.focus();
      }
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl["default"], {
    disabled: disabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Search, {
      disabled: disabled,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SearchIconWrapper, {
        onClick: function onClick() {
          var _inputRef$current;
          setFocused(true);
          (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
          title: tooltip,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search["default"], {
            color: disabled ? 'inherit' : 'action'
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInputBase, {
        placeholder: placeholder,
        inputProps: {
          'aria-label': 'search',
          className: (0, _clsx4["default"])(_defineProperty({}, FOCUSED_CLASS_NAME, focused || expanded))
        },
        expandedWidth: expandedWidth,
        value: value,
        onChange: handleChange,
        debounceTimeout: debounceTimeout,
        actionCount: actionCount,
        inputRef: inputRef
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SearchActions, {
        expanded: expanded,
        children: actionsToRender
      })]
    })
  });
});